import { gql } from "@apollo/client";

export const DEAL_FIELDS = gql`
  fragment DealFields on Deal {
    id
    domain
    setId
    schemaType
    name
    status
    stage
    side
    dealType
    clientContactId
    propertyAssetIds
    resolutionStatus
    data
    createdAt
    updatedAt
  }
`;

export const GET_DEALS = gql`
  query GetDeals($input: DealsInput!) {
    deals(input: $input) {
      total
      deals {
        ...DealFields
      }
    }
  }
  ${DEAL_FIELDS}
`;

export const GET_OUTSTANDING_OUTREACH = gql`
  query GetOutstandingOutreach($domain: String!, $dealId: ID!) {
    outstandingOutreach(domain: $domain, dealId: $dealId) {
      summary
      contacted {
        propertyAssetId
        propertyLabel
        lastTouchAt
        lastOutcome
        contactName
      }
      untouched {
        propertyAssetId
        propertyLabel
      }
    }
  }
`;
